import { ControlLink, Stack } from '@moda/om';
import React, { Fragment } from 'react';
import { SITE_FOOTER_LINKS_CONFIG } from '../siteFooterLinksConfig';

export const SiteFooterLinksMobile: React.FC = () => (
  <Stack className="SiteFooterLinksMobile" space={2}>
    {SITE_FOOTER_LINKS_CONFIG.filter(({ hiddenOnMobile }) => !hiddenOnMobile).map(
      siteFooterLinkCategory => (
        <Fragment key={siteFooterLinkCategory.name}>
          {siteFooterLinkCategory.links.map(siteFooterLink => (
            <div key={siteFooterLink.label}>
              <ControlLink href={siteFooterLink.href} underlined={false} target="_blank">
                {siteFooterLink.mobileLabel || siteFooterLink.label}
              </ControlLink>
            </div>
          ))}
        </Fragment>
      )
    )}
  </Stack>
);
